module.exports = __webpack_public_path__ + "static/img_dxzm_0110.5e134483.png";